import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { AlertComponent } from './alert.component';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'ui-alerts',
  templateUrl: './alert-container.component.html',
  styleUrl: './alert-container.component.scss',
  imports: [AlertComponent, NgClass],
  host: {
    '[style.--ui-alerts-top]': 'topOffset()'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertContainerComponent {
  protected readonly alerts = inject(AlertService);

  /**
   * Distance of the alerts stack from the top of the screen (applies to all alerts).
   * A number is treated as px. When unset the `--ui-alerts-top` css variable (default 20px) is used.
   */
  readonly top = input<number | string>();

  // Number => px; unset/null/undefined leaves the css var (and its default) in place
  protected readonly topOffset = computed(() => {
    const t = this.top();
    return typeof t === 'number' ? `${t}px` : t;
  });
}
